var EventEmitter = require("events");
module.exports = new EventEmitter();